import { ArrowLeft, ArrowRight } from "lucide-react";
import { Button } from "../ui/button";

type AddTestPageNavButtons = {
  nextTitle?: string;
  step: number;
  handlePageChangeUp: any;
  handlePageChangeDown: any;
  disabled?: boolean;
};

export default function AddTestPageNavButtons(fn: AddTestPageNavButtons) {
  const disabledBackButton = fn.step === 0;
  const disabledNextButton = fn.step === 4;
  return (
    <div className="grid grid-cols-2 w-full py-5 px-12 md:px-24 mt-auto">
      <Button
        variant="outline"
        onClick={() => fn.handlePageChangeDown()}
        disabled={disabledBackButton}
        className="gap-2"
      >
        <ArrowLeft className="h-4 w-4" />
        Back
      </Button>
      <Button
        onClick={() => fn.handlePageChangeUp()}
        disabled={disabledNextButton || fn.disabled}
        className="justify-self-end gap-2"
      >
        {fn.nextTitle ? fn.nextTitle : "Next"}
        <ArrowRight className="h-4 w-4" />
      </Button>
    </div>
  );
}
